import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

import Cluster from '../Support/Cluster';

const footer = (props) => {

	let wrap_class = 'wrapper clearfix';
	if(window.location.pathname === '/register') wrap_class += ' wrapper--narrow';

	let sock_class = 'sock screen-only';
	if(window.location.pathname === '/matter/new') sock_class = 'sock';

	return (
		<Cluster>
			<div className={sock_class}></div>
			<footer className='footer relative screen-only'>

				<div className={wrap_class}>

					<div className='footer__content footer__content--left pull-left'>
						<p>&copy; Copyright { new Date().getFullYear() } Hall Chadwick Melbourne Pty Ltd A.B.N. 88 081 186 450. All rights reserved.<br />Liability limited by a scheme approved under Professional Standards Legislation.</p>
					</div>

					<div className='footer__mobile footer__mobile--left pull-left--small'>
						<p>&copy; { new Date().getFullYear() } Hall Chadwick Melbourne Pty Ltd A.B.N. 88 081 186 450. All rights reserved.</p>
					</div>

					<div className='footer__content footer__content--right pull-right'>
						<p><strong>Hall Chadwick Forensics Level 14 440 Collins Street Melbourne Australia</strong><br /><a href='tel:61398206400' rel='noopener noreferrer'><svg className='fas fa-phone' /> +61 3 9820 6400</a> <a href='http://www.hallchadwickmelb.com.au' target='_blank' rel='noopener noreferrer'><svg className='fas fa-globe' /> www.hallchadwickmelb.com.au</a> <a href='mailto:forensics@hallchadwickmelb.com.au' rel='noopener noreferrer'><svg className='fas fa-at' /> forensics@hallchadwickmelb.com.au</a></p>
					</div>

					<div className='footer__mobile footer__mobile--right pull-right--small'>
						<p><button className='btn btn--over btn--teeny' onClick={() => props.rdxSetModal('info')}><i className='fas fa-info-circle'></i> Info</button></p>
					</div>

				</div>

			</footer>
			<footer className='print print--footer'>

				<div className='wrapper clearfix'>

					<div className='pull-left'>
						<p>&copy; Copyright { new Date().getFullYear() } Hall Chadwick Melbourne Pty Ltd A.B.N. 88 081 186 450. All rights reserved.<br />Liability limited by a scheme approved under Professional Standards Legislation.<br />Hall Chadwick Forensics Level 14 440 Collins Street Melbourne Australia</p>
					</div>

					<div className='pull-right'>
						<ul>
							<li><a href='tel:61398206400' rel='noopener noreferrer'><svg className='fas fa-phone' /> +61 3 9820 6400</a></li>
							<li><a href='http://www.hallchadwickmelb.com.au' target='_blank' rel='noopener noreferrer'><svg className='fas fa-globe' /> www.hallchadwickmelb.com.au</a></li>
							<li><a href='mailto:forensics@hallchadwickmelb.com.au' rel='noopener noreferrer'><svg className='fas fa-at' /> forensics@hallchadwickmelb.com.au</a></li>
						</ul>
					</div>

				</div>

			</footer>
		</Cluster>
	);
}

const mapDispatchToProps = dispatch => {
	return {
		rdxSetModal: (content) => dispatch(actions.setModal(content))
	};
}


export default connect(null,mapDispatchToProps)(footer);


// WEBPACK FOOTER //
// ./src/Blocks/Footer.js